import { CSSProperties } from "react";
import { useShimmerEffect } from "./useShimmerEffect";

export interface ShimmerEffectBoxProps {
  fontSize?: CSSProperties["fontSize"];
  width?: CSSProperties["width"];
  height?: CSSProperties["height"];
  inline?: boolean;
  style?: CSSProperties;
  className?: string;
  borderRadius?: string | number;
}

/**
 * 大きさを指定したローディング用の表示を作ることができます。
 *
 * **使用例**
 *
 * - ローディングが終わるまで大きさが不確定な要素
 * - カードリスト表示など、列挙される要素群
 */
export const ShimmerEffectBox = ({
  width,
  height,
  fontSize,
  borderRadius,
  inline,
  ...props
}: ShimmerEffectBoxProps) => {
  const style = useShimmerEffect();
  return (
    <div
      css={[
        {
          display: inline ? "inline-flex" : "flex",
          alignItems: "center",
          justifyContent: "center",
          width: width ?? "",
          height: height ?? "100%",
        },
      ]}
      {...props}
    >
      <div
        css={[
          style,
          {
            position: "relative" as const,
            width: "100%",
            height: fontSize ?? "100%",
            borderRadius: borderRadius,
          },
        ]}
      />
    </div>
  );
};
